export default {
    abilities: 'Abilities',
    abilityOne: {
        title: 'Locate or obtain information.',
        desc:
            'You are at a <strong> {0} </strong> level of reading, we invite you to continue exercising to maintain your compression capacity.',
    },
    abilityTwo: {
        title: 'Integrate and interpret.',
        desc:
            'You are at a <strong> {0} </strong> level of reading, we invite you to strengthen your reading skills.',
    },
    abilityThree: {
        title: 'Reflect and assess.',
        desc:
            'You are at a <strong> {0} </strong> level of reading, we invite you to develop and improve your reading skills.',
    },
    abilityLevels: ['initial', 'intermediate', 'advanced'],
    achievements: 'Achievements',
    answered_questions: 'Answered Questions',
    back_to_avatars: 'Back to avatars',
    back_to_skins: 'Back to skins',
    buy_this_avatar: 'Buy this avatar',
    buy_this_skin: 'Buy this skin',
    correct_answers: 'Correct Answers',
    edit_avatar: 'Edit avatar',
    edit_my_avatar: 'Edit my avatar',
    edit_skin: 'Edit Skin',
    global_progress: 'Global progress',
    global_progress_rank: ['4 Weeks', '8 Weeks', '12 Weeks'],
    leave: 'Leave',
    level: 'Level',
    my_categories: 'My categories',
    my_skins: 'My skins',
    points: 'Points',
    purchase_avatar_desc:
        'This is a special avatar that you can acquire by purchasing it with your Beecoins. Once you buy it, it will be available in "Special avatars".',
    purchase_skin_desc:
        'This is a special skin that you can acquire by buying it with your Beecoins. Once you buy it, it will be available in "Special skins".',
    save_changes: 'Save changes',
    special_avatar: 'Special avatar',
    special_avatars: 'Special avatars',
    standard_avatars: 'Standard avatars',
    special_skin: 'Special skin',
    special_skins: 'Special skins',
    standard_skins: 'Standard skins',
    you_have: 'You have',
    your_collection: 'Your collection',
    your_favorite_books: 'Your favorite books',
    your_favorite_books_desc: 'Review the books you selected as must-see in your collection.',
    your_profile: 'Your profile',
    menu_edit_tooltip: 'With this button you can modify your Avatar, your Skin and your Favorite Categories.',
    student_code: 'Student code',
    student_code_message: 'Code copied to the clipboard'
}
